import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  adminRoutes,
  physicalCardRoutes,
  financeRoutes,
  marketingRoutes,
  aquaManagerRoutes,
  lwwTicketRoutes,
} from "../../config";
import { useUserContext } from "../../contexts/UserContext";
import TopbarItem from "../Topbar/TopbarItem";

type ModalSidebarProps = {
  open: boolean;
  onRoute: (route: string) => void;
  onCloseModal: () => void;
  activePath: string;
};

const ModalSidebar = ({
  open,
  onRoute,
  activePath,
  onCloseModal,
}: ModalSidebarProps) => {
  const { user } = useUserContext();
  const navigate = useNavigate();
  const handleOnLogout = () => {
    // setIsOpenLogout(false);
    localStorage.removeItem("userData");
    // localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/auth/login");
  };

  const useOutsideAlerter = (ref: any) => {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          onCloseModal();
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef);

  return (
    <>
      {open && (
        <StyledModalSidebar>
          <SidebarContainer ref={wrapperRef}>
            <SidebarLogoContainer>
              <SidebarLogo
                src={require("../../assets/images/logo-hug.png")}
                alt="logo"
              />
            </SidebarLogoContainer>
            {Number(user) === 1 && (
              <>
                {adminRoutes.map((route: any, idx) => (
                  <TopbarItem
                    key={idx}
                    route={route}
                    activePath={activePath}
                    onRoute={onRoute}
                  />
                ))}
              </>
            )}
            {Number(user) === 2 && (
              <>
                {physicalCardRoutes.map((route: any, idx: number) => {
                  return (
                    <TopbarItem
                      key={idx}
                      route={route}
                      activePath={activePath}
                      onRoute={onRoute}
                    />
                  );
                })}
              </>
            )}
            {Number(user) === 3 && (
              <>
                {financeRoutes.map((route: any, idx: number) => {
                  return (
                    <TopbarItem
                      key={idx}
                      route={route}
                      activePath={activePath}
                      onRoute={onRoute}
                    />
                  );
                })}
              </>
            )}
            {Number(user) === 4 && (
              <>
                {marketingRoutes.map((route: any, idx: number) => {
                  return (
                    <TopbarItem
                      key={idx}
                      route={route}
                      activePath={activePath}
                      onRoute={onRoute}
                    />
                  );
                })}
              </>
            )}
            {Number(user) === 5 && (
              <>
                {aquaManagerRoutes.map((route: any, idx: number) => {
                  return (
                    <TopbarItem
                      key={idx}
                      route={route}
                      activePath={activePath}
                      onRoute={onRoute}
                    />
                  );
                })}
              </>
            )}
            {Number(user) === 6 && (
              <>
                {lwwTicketRoutes.map((route: any, idx: number) => {
                  return (
                    <TopbarItem
                      key={idx}
                      route={route}
                      activePath={activePath}
                      onRoute={onRoute}
                    />
                  );
                })}
              </>
            )}
            <div>
              <LogoutButton onClick={handleOnLogout}>
                <img
                  src={require("../../assets/images/majesticons_door-exit.png")}
                  alt="majesticons_door-exit"
                />
                <span>{"Logout"}</span>
              </LogoutButton>
            </div>
          </SidebarContainer>
        </StyledModalSidebar>
      )}
    </>
  );
};

const SidebarLogo = styled.img`
  width: 100%;
`;

const SidebarLogoContainer = styled.div`
  padding: 2rem;
`;

const StyledModalSidebar = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    position: absolute;
    z-index: 999;
    display: flex;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }
`;

const SidebarContainer = styled.div`
  background: rgb(0, 0, 0);
  width: 80%;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const LogoutButton = styled.button`
  @media only screen and (min-height: 860px) {
    // position: absolute;
  }
  background: transparent;
  border: none;
  z-index: 99;
  bottom: 0;
  color: white;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  font-family: Poppins-Medium;

  > span {
    margin-left: 1rem;
  }
`;

export default ModalSidebar;
